<template>
  <ss-modal
    v-show="isVisible"
    class="lg"
    title="Title"
    intro="bounceIn"
    outro="bounceOut">
    <div slot="modal-header">
      Wpisane zobowiązania
      <i class="close" @click="handleClose(false)"></i>
    </div>

    <div slot="modal-body">
        <table class="table mb-3 responsive-table">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0">Nazwa wierzyciela</th>
              <th scope="col" class="border-0">Wysokość hipoteki</th>
              <th scope="col" class="border-0">Wysokość zadłużenia</th>
              <th scope="col" class="border-0">Czy spłacone naszą pożyczką</th>
              <th scope="col" class="border-0 text-right">Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(obligation, index) in localObligations" :key="index">
              <td>
                <dt class="d-block d-sm-none">Nazwa wierzyciela</dt>
                <d-input
                  v-model="obligation.creditor_name"
                  :disabled="actionInProgress"
                  placeholder="Podaj nazwę wierzyciela" />
              </td>
              <td>
                <dt class="d-block d-sm-none">Wysokość hipoteki</dt>
                <ss-price-input
                  v-model="obligation.mortgage_value"
                  :disabled="actionInProgress"
                  placeholder="Kwota (zł)" />
              </td>
              <td>
                <dt class="d-block d-sm-none">Wysokość zadłużenia</dt>
                <ss-price-input
                  v-model="obligation.debt_value"
                  :disabled="actionInProgress"
                  placeholder="Kwota (zł)" />
              </td>
              <td>
                <dt class="d-block d-sm-none">Czy spłacone naszą pożyczką</dt>
                <d-select
                  v-model="obligation.paid_our_loan"
                  :disabled="actionInProgress">
                  <option :value="1">Tak</option>
                  <option :value="0">Nie</option>
                </d-select>
              </td>
              <td class="text-right">
                <d-button
                  class="mx-1 my-1"
                  theme="danger"
                  @click.prevent="removeObligation(index)"
                  :disabled="actionInProgress">
                  <i class="material-icons">delete</i>
                </d-button>
              </td>
            </tr>
            <tr v-if="!localObligations.length">
              <td colspan="5" class="text-center text-info">
                Brak zobowiązań do wyświetlenia.
              </td>
            </tr>
          </tbody>
        </table>

        <d-button
          theme="primary"
          @click.prevent="addObligation"
          :disabled="actionInProgress">
          <i class="material-icons">add</i> Dodaj zobowiązanie
        </d-button>
    </div>

    <div slot="modal-footer">
      <d-button
        theme="danger"
        @click.prevent="handleClose(false)"
        :class="{ disabled: actionInProgress }">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      
      <d-button
        theme="success"
        :class="{ 'ml-3': true, 'isLoading': actionInProgress }"
        :disabled="actionInProgress"
        @click.prevent="save">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal';
import SsPriceInput from '@/components/common/SsPriceInput';
import GuaranteeUtils from '@/utils/guarantee.js';

export default {
  name: 'GuaranteeObligationsModal',
  components: {
    SsModal,
    SsPriceInput
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    guarantee: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      localObligations: [],
      actionInProgress: false,
    };
  },
  mounted() {
    this.localObligations = this.guarantee.obligations || [];
  },
  methods: {
    addObligation () {
      const newObligation = {
        creditor_name: '',
        mortgage_value: null,
        debt_value: null,
        paid_our_loan: 0
      };
    
      this.localObligations.push(newObligation);
    },
    removeObligation (index) {
      this.localObligations.splice(index, 1);
    },
    handleClose (shouldReload) {
      if (this.actionInProgress) {
        return;
      }

      this.$emit('close', shouldReload);
    },
    save () {
      this.actionInProgress = true;

      const guaranteeData = { ...this.guarantee };
      guaranteeData.obligations = this.localObligations;

      GuaranteeUtils.saveGuarantee(guaranteeData, this.guarantee.client_id, this.handleSaveSuccess, this.handleSaveError);
    },
    handleSaveSuccess () {
      this.actionInProgress = false;
      this.$emit('saved');
      this.handleClose(true);
    },
    handleSaveError (error) {
      this.actionInProgress = false;
      console.error(error);

      if (error && error.response && error.response.data && error.response.data.errors) {
        LarErrors.record(error.response.data.errors)
      }
    }
  }
};
</script>

